import {api} from '../../api';
import {createMutation} from '../../lib';

const {putPaymentCreate} = api.payment;

export const usePutPaymentCreateMutation = createMutation((params: Parameters<typeof putPaymentCreate>) => {
  const [query, data, reqParams] = params;
  return putPaymentCreate(query, data, reqParams);
});
